import formatLanguage from '@smart-tv/utils/formatter/format-language';
import { AudioTrack } from '../types';

const SURROUND_CHANNELS = '6';

const getAudioTrackDisplayText = ({ lang, channels, roles, label }: AudioTrack) => {
  let language = formatLanguage(lang);

  if (roles?.includes('commentary') && label?.includes('AD')) {
    language = `${language} Synstolkning (AD)`;
  }

  const channel = channels === SURROUND_CHANNELS ? ' | 5.1' : '';

  return `${language}${channel}`;
};

export default getAudioTrackDisplayText;
